// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.iconfont {\n  font-family: 'iconfont' !important;\n  font-size: 16px;\n  font-style: normal;\n  display: inline-block;\n  text-rendering: auto;\n}\n\n", ""]);
// Exports
module.exports = exports;
